import { DEFAULT_LOCALE, UserLocale } from '@/shared/config';

import { CountryNames } from '../config';

export const getCountryName = (
  countryCode: string,
  names: CountryNames,
  locale: UserLocale,
): string => names[locale] || names[DEFAULT_LOCALE] || countryCode;
